module.exports = __webpack_public_path__ + "img/free-standing-wall-0.c3790c27.jpeg";